module.exports = __webpack_public_path__ + "static/media/powered-by-stripe.3e0cf333.svg";